import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { SectionWrapper } from './ui/SectionWrapper';
export function Hero() {
  return <section className="relative bg-brand-cream pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-55">
          {/* Image - Mobile Top, Desktop Right */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-56">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-57">
              <div className="absolute inset-0 bg-brand-teal/10 mix-blend-multiply" data-id="element-58"></div>
              <img src="https://cdn.magicpatterns.com/uploads/gjBTATEAfvuZr2nVsR2ZPh/40.Inflamacion.png" alt="Inflamación Zero 48h - Guía Digital" className="w-full h-auto object-cover" data-id="element-59" />
            </div>
          </div>

          {/* Content - Mobile Bottom, Desktop Left */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1 text-center lg:text-left" data-id="element-60">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-61">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-dark leading-tight mb-6" data-id="element-62">
                El Método Inflamación Zero 48h:{' '}
                <span className="text-brand-teal" data-id="element-63">
                  Deshincha tu Cuerpo y Recupera tu Energía
                </span>{' '}
                en Solo un Fin de Semana
              </h1>

              <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-10 font-medium" data-id="element-64">
                El protocolo de "Micro-Ayunos de Cortisol" diseñado para hombres
                y mujeres de más de 40 años que viven en USA y están cansados de
                despertar con pesadez, dolor articular y el abdomen inflamado.
              </p>

              <CTAButton className="lg:mx-0" data-id="element-65" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}
import { motion } from 'framer-motion';